/**
 * Checks for media elements in a bootstrap modal,
 * removes and readds elements on dismiss to prevent
 * audio playing in background.
 *
 * @param {HTMLElement} modal
 * @returns void
 */
export const maybeSilenceModalOnDismiss = (modal) => {
	if (!modal.querySelectorAll('video, iframe, audio').length) {
		console.log('No media found');
		return;
	}
	modal.addEventListener('hidden.bs.modal', () => {
		const content = modal.innerHTML;
		modal.innerHTML = content;
	});
};

export const silenceModalsOnDismiss = () => {
	Array.from(document.querySelectorAll('.modal')).forEach(
		maybeSilenceModalOnDismiss
	);
};
